import axios from 'axios';
import { setAlert } from './alert';

import {
        GET_ALLCANDS, ALLCANDS_ERROR, SET_COUNT, SET_ALLOTED, SET_DBCALL, RESET_LOADING, RESET_DBCALL, CLEAR_ALLCANDS
    } from './types';

export const getRanks = () => async dispatch => {
    try {
      dispatch({
        type: SET_DBCALL
      });

      const res = await axios.get('/api/rank/get');
        
      console.log("finished retrieving");

      console.log(res.data);

      dispatch({
        type: GET_ALLCANDS,
        payload: res.data
      });

     
      dispatch({
        type: RESET_DBCALL
      });

    } catch (err) {

      dispatch({
        type: ALLCANDS_ERROR,
        payload: { msg: err.response.statusText, status: err.response.status }
      });

    }
  };
  

export const calCutoffs = () => async dispatch => {
    try {
      dispatch({
        type: SET_DBCALL
      });

      const res = await axios.get('/api/rank/cutoffs');
        
      console.log("finished calling cutoffs");

      console.log(res.data);

      dispatch({
        type: RESET_LOADING
      });

      dispatch({
        type: RESET_DBCALL
      });

    } catch (err) {

      dispatch({
        type: ALLCANDS_ERROR,
        payload: { msg: err.response.statusText, status: err.response.status }
      });

    }
  };

  export const calRanks = () => async dispatch => {
    try {

      dispatch({
        type: SET_DBCALL
      });

      const res = await axios.get('/api/rank/ranks');
        
      console.log("finished calling ranks");

      dispatch({
        type: RESET_LOADING
      });

      dispatch({
        type: RESET_DBCALL
      });

      console.log(res.data);

    } catch (err) {

      dispatch({
        type: ALLCANDS_ERROR,
        payload: { msg: err.response.statusText, status: err.response.status }
      });

    }
  };

  export const clearReport = (history) => async dispatch => {
    //console.log("clearing the profile");
    dispatch({
        type: CLEAR_ALLCANDS,
        payload: null
    });

    //history.push('/dashboard');
  };


  export const genRands = minVal => async dispatch => {
    try {

    console.log("Invoking random generation with " + minVal);
    
    dispatch({
      type: SET_DBCALL
    });

     const res2 = await axios.get(`/api/rank/rands/${minVal}`);      
      
      console.log("Completed generating randomnos");
      console.log(res2);

      dispatch({
        type: RESET_LOADING
      });

    dispatch({
      type: RESET_DBCALL
    });

    }
    
    catch (err) {

        console.log("Catch");
        
        dispatch(setAlert(err.response.data.msg, 'danger'));
        
        /*console.log(err.response.data);
        const errors = err.response.data;

        if(errors) {
            errors.forEach(error => dispatch(setAlert(errors, 'danger')));
        }*/

        dispatch({
          type: ALLCANDS_ERROR,
          payload: { msg: err.response.statusText, status: err.response.status }
          });

    }
};


export const schTfcs = (formData) => async dispatch => {
  const config = {
      headers: {
          'Content-type': 'application/json'            
      }
  }    
  //const body = JSON.stringify(formData);

  console.log("got in middle ");
  console.log(formData);
 
  try {

    
    if((formData.exyes === 'y') && (formData.disyes === 'y')) {
      console.log("dispatched schedule for ex");
     const res = await axios.post('/api/rank/schboth', formData, config);
     console.log("Returned from db");
     console.log(res.data);

     console.log("back to client");
    }
    else if(formData.exyes === 'y') {
           console.log("dispatched schedule for ex");
          const res = await axios.post('/api/rank/schex', formData, config);
          console.log("Returned from db");
          console.log(res.data);

          console.log("back to client");
    }

    else if(formData.disyes === 'y') {
        console.log("dispatched schedule for dap");
        const res = await axios.post('/api/rank/schdap', formData, config);
        console.log("Returned from db");
        console.log(res.data);

        console.log("back to client");

    }

    else if(formData.exyes === 'n' && formData.disyes === 'n') {
      
      console.log("dispatched schedule for any");
      const res = await axios.post('/api/rank/schany', formData, config);
      console.log("Returned from db");
      console.log(res.data);

      console.log("back to client");

    }


      dispatch(setAlert("Created Schedule", 'success'));

  } catch (err) {

      const errors = err.response.data.errors;

      if(errors) {
          errors.forEach(error => {
              dispatch(setAlert(error.msg, 'danger'));
          });
      }
      
  }
};

export const schCount = (formData) => async dispatch => {
  const config = {
      headers: {
          'Content-type': 'application/json'            
      }
  }    
 // const body = JSON.stringify(formData);
 
  try {
      console.log("dispatched count");
      const res = await axios.post('/api/rank/schcount', formData, config);
      console.log("Returned from db");
      console.log(res.data);

      dispatch(setAlert("Count retrieved", 'success'));

      dispatch({
            type: SET_COUNT,
            payload: res.data
        });

  } catch (err) {

      const errors = err.response.data.errors;

      if(errors) {
          errors.forEach(error => {
              dispatch(setAlert(error.msg, 'danger'));
          });
      }
      
  }
};

export const schAlloted = (formData) => async dispatch => {
  const config = {
      headers: {
          'Content-type': 'application/json'            
      }
  }    
 // const body = JSON.stringify(formData);
 
  try {

        console.log("dispatched alloted");
        const res2 = await axios.post('/api/rank/schalr', formData, config);
        console.log("Returned from db");
        console.log(res2.data);
  
        dispatch(setAlert("Count retrieved", 'success'));
  
        dispatch({
              type: SET_ALLOTED,
              payload: res2.data
          });
  

  } catch (err) {

      const errors = err.response.data.errors;

      if(errors) {
          errors.forEach(error => {
              dispatch(setAlert(error.msg, 'danger'));
          });
      }
      
  }
};

export const schApplns = (formData) => async dispatch => {
  const config = {
      headers: {
          'Content-type': 'application/json'            
      }
  }    
 // const body = JSON.stringify(formData);
 
  try {

        console.log("dispatched alloted");
        const res2 = await axios.post('/api/rank/schapplns', formData, config);
        console.log("Returned from db");
        console.log(res2.data);
  
        dispatch(setAlert("Applns retrieved", 'success'));
  
        dispatch({
              type: GET_ALLCANDS,
              payload: res2.data
          });
  

  } catch (err) {

      const errors = err.response.data.errors;

      if(errors) {
          errors.forEach(error => {
              dispatch(setAlert(error.msg, 'danger'));
          });
      }
      
  }
};


export const getRandomnos = () => async dispatch => {
  try {

    const res = await axios.get('/api/rank/showrands');
      
    console.log("finished retrieving");

    console.log(res.data);

    dispatch({
      type: GET_ALLCANDS,
      payload: res.data
    });

    dispatch({
      type: RESET_DBCALL
    });

  } catch (err) {

    dispatch({
      type: ALLCANDS_ERROR,
      payload: { msg: err.response.statusText, status: err.response.status }
    });

  }
};
